module.exports = __webpack_public_path__ + "img/img1.77fb0652.png";